import { useEffect, useState } from "react";

export const Mostrar = ({ name, value, onChange }) => {
    const [state, setState] = useState([]);
    return (
        <select
            className="select-motivo"
            name={name}
            value={value}
            onChange={onChange}
        >
            <option value="S">Si</option>
            <option value="N">No</option>
        </select>
    );
};
